module.exports = {
  LIST_TEAM_PRESENTATIONS: 'list-team-presentations',
  ADD_TEAM_MEMBER: 'add-team-member',
  REMOVE_TEAM_MEMBER: 'remove-team-member',
  LEAVE_TEAM: 'leave-team',
  EDIT_ROLE: 'edit-role',
  VIEW_LICENSES_USED: 'view-licenses-used',
  VIEW_MEMBER_LIST: 'view-member-list',
  VIEW_MEMBER_ACTIVITIES: 'view-member-activities',
  VIEW_PRESENTATION: 'view-presentation',
  PRESENT: 'present',
  CREATE_PRESENTATION: 'create-presentation',
  CREATE_FOLDER: 'create-folder',
  INVITED_TO_EDIT_OTHER_TEAM_MEMBER: 'invited-to-edit-other-team-member',
  VIEW_LIST_PRESENTATIONS: 'view-list-presentations',
  VIEW_SLIDES: 'view-slides',
  DELETE_TEAM_PRESENTATIONS: 'delete-team-presentations',
  RENAME_PRESENTATION: 'rename-presentation',
  INVITE_TO_EDIT: 'invite-to-edit',
  SHARE_A_COPY: 'share-a-copy',
  TAKE_OVER_TO_EDIT: 'take-over-to-edit',
  PUBLISH_TO_TEMPLATE_LIBRARY: 'publish-to-template-library',
  CLEAR_RESULT: 'clear-result',
  COPY_PRESENTATIONS_ACROSS_WORKSPACES: 'copy-presentations-across-workspaces',
}
